"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "morazzone": {
    "033b39e2": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-coronaccio": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "979c3f10": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-mezzanella": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72dca56f": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-pagliate": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a130377": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cab64ae1": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-roncaccio": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42095bd4": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-ronchetto": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bbc89510": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "skipSearch": false
    }],
    "cuffia": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "98be41eb": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "skipSearch": false
    }],
    "tamborino": [{
      "hkey": "0c332943",
      "slug": "morazzone",
      "name": "Morazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;